import { X } from 'lucide-react';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { Button } from './ui/Button';

export const MaintenanceBanner = () => {
  const { isFeatureEnabled: isMaintenanceBannerEnabled } =
    useFeatureFlag('maintenance-banner');

  if (!isMaintenanceBannerEnabled) {
    return <></>;
  }

  let banner: string | null = null;
  try {
    banner = localStorage.getItem('maintenance-banner');
  } catch {
    banner = null;
  }

  if (banner) {
    return <></>;
  }

  const handleCloseBanner = () => {
    try {
      localStorage.setItem('maintenance-banner', 'true');
    } catch {
      console.error('Failed to store banner state');
    }
    window.location.reload();
  };

  return (
    <div className="bg-gradient-to-br from-purple-200 to-white dark:from-black dark:to-black fixed top-0 w-full z-50 shadow-lg">
      <div className="relative flex items-center gap-x-6 overflow-hidden font-sans text-foreground px-6 py-2.5 sm:px-3.5 sm:before:flex-1 w-full">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          <p className="text-sm/6 text-gray-900 dark:text-white">
            <strong>Scheduled Maintenance </strong>- will be undergoing
            scheduled maintenance on 2026/08/26 at 8:00AM BST for approximately
            4 hours. We apologize for any inconvenience.
          </p>
        </div>
        <div className="flex flex-1 justify-end">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={handleCloseBanner}
            aria-label="Dismiss maintenance notice"
          >
            <X className="text-gray-900 dark:text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};
